import * as types from '../mutation-types'

const moduleCheckout = {
	state: {
		endereco: {},
		dadosCompra: {},
		total: 0
	},
	getters: {
		endereco: state => { return state.endereco },
		dadosCompra: state => { return state.dadosCompra },
		total: state => { return state.total },
	},
	mutations: {
		[types.ADD_ENDERECO](state, endereco) {
			const record = state.endereco
			if (endereco.operacao == 'ALTER_ENTREGA' && record)
				record.entrega = endereco.entrega
			else
				state.endereco = endereco
		},
		[types.ADD_DADOSCOMPRA](state, dadosCompra) { state.dadosCompra = dadosCompra },
		[types.ADD_TOTAL](state, total) { state.total = total },
	},
	actions: {
		addEndereco({ commit }, endereco) {
			commit(types.ADD_ENDERECO, endereco)
		},
		addDadosCompra({ commit }, dadosCompra) {
			commit(types.ADD_DADOSCOMPRA, dadosCompra)
		},
		addTotal({ commit }, total) {
			commit(types.ADD_TOTAL, total)
		},
	},
}
export default moduleCheckout